import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions } from '@angular/material/tooltip';

import { openConfigurationDialog } from '../../configuration/configuration-dialog/configuration-dialog.component';
import { CommandConversationService } from '../../services/command-conversation.service';
import { AuthService } from '../../services/auth.service';

/** App-shell destinations; object pages are owned by the Map tree. */
export type ViewTabId = 'overview' | 'dashboard' | 'campaigns' | 'files';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
  providers: [{
    provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
    useValue: {
      position: 'right',
      showDelay: 400,
      hideDelay: 0,
      touchendHideDelay: 1500,
      disableTooltipInteractivity: true,
    } satisfies MatTooltipDefaultOptions,
  }],
})
export class SidebarComponent {
  @Input() expanded = false;
  @Output() expandedChange = new EventEmitter<boolean>();
  editingConversationId: string | null = null;

  toggleSidebar(): void { this.expandedChange.emit(!this.expanded); }

  showConversations(): void { this.expandedChange.emit(true); }

  startRename(id: string): void {
    this.editingConversationId = id;
    setTimeout(() => {
      const input = this.host.nativeElement.querySelector<HTMLInputElement>('.conversation-rename');
      input?.focus();
      input?.select();
    });
  }

  finishRename(id: string, title: string): void {
    if (this.editingConversationId !== id) return;
    this.convo.renameConversation(id, title);
    this.editingConversationId = null;
  }

  @Input() activeViewTab: ViewTabId | null = null;
  @Output() viewTabChange = new EventEmitter<ViewTabId>();

  constructor(
    public auth: AuthService,
    private router: Router,
    private dialog: MatDialog,
    public convo: CommandConversationService,
    private host: ElementRef<HTMLElement>,
  ) {}

  onViewTabClick(id: ViewTabId): void {
    // The route remains the source of truth for the selected navigation entry.
    this.viewTabChange.emit(id);
  }

  logout(): void {
    this.auth.logout().subscribe({
      complete: () => this.router.navigateByUrl('/'),
      error: () => this.router.navigateByUrl('/'),
    });
  }

  goToLogin(): void {
    this.auth.openLoginDialog();
  }

  openConfiguration(): void {
    openConfigurationDialog(this.dialog);
  }

  accountEmail(): string {
    return this.auth.getEmail() ?? 'Account';
  }

  accountInitials(): string {
    const email = this.auth.getEmail();
    const local = email?.split('@')[0] ?? '';
    return (local.slice(0, 2) || '?').toUpperCase();
  }

}
